// Thumbnails data store

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import { getAPI, token } from "@/api/params.js";

import { CHANNEL_TYPE } from "@/constants.js";

dayjs.extend(utc);

const state = {
  // is thumbnail data loaded
  loaded: false,
  // thumbnails storage URL
  base: "",
  // channel thumbnails path
  path: "",
  // time shift between two thumbnails (in seconds)
  step: 0,
  /*delay: 0,*/
  // thumbnail width (relative)
  width: null,
  // thumbnail height (relative)
  height: null,
  // first thumbnail information
  first: {
    /** First thumbnail index for getting from server
     *
     * Thumbnail index is seconds count of hour when
     * thumbnail was generated ronded up to be multiple of step
     */
    index: 0,
    // timestamp of first thumbnail
    ts: 0
  }
};

const getters = {
  // get link to thumbnail, corresponding to timestamp time
  getThumbnailLink: state => timestamp => generateLink(state, timestamp),
  // is thumbnails parameters loaded
  isLoaded: state => state.loaded
};

const mutations = {
  /**
   * Set thumbnails parameters
   */
  updateStatus: function(state, json) {
    state.path = json.path;
    state.step = json.step;
    state.width = json.width;
    state.height = json.height;
    state.first.ts = json.first.ts;
    state.first.index = json.first.index;
    // const startMoment = dayjs.unix(json.first.ts).utc();
    // const expectedStartIndex = getSecondsOfHour(startMoment);

    //let delay = state.first.index - expectedStartIndex;

    /*if (delay > 0) {
            delay -= 3600;
        }*/
    //state.delay = delay;
    state.loaded = true;
  },
  /**
   * Set thumbnails storage base URL
   */
  updateBase: function(state, services) {
    state.base = `${services.thumbs}`;
  }
};

const actions = {
  /**
   * Load thumbnails parameters from API
   */
  loadThumbnails: async function({ commit, rootState }) {
    if (rootState.services.channelType == CHANNEL_TYPE.VIDEO) {
      console.log("Thumbnails loading...");
      try {
        const thumbnailsResponse = await fetch(
          `${getAPI()}/thumbnails?app=${rootState.services.app}&stream=${
            rootState.services.stream
          }&token=${token}`
        );
        const responseJson = await thumbnailsResponse.json();
        commit("updateBase", rootState.services);
        commit("updateStatus", responseJson.data);
      } catch (e) {
        console.warn("Unable to load thumbnails info ", e);
      }
    } else {
      console.warn("Attempt to call load thumbnails for no-video channel");
    }
  }
};

/**
 * Create link to thumbnail by unix timestamp
 * @param {Object} state Store object
 * @param {Number} targetTS Thumbnail timestamp
 */
function generateLink(state, targetTS) {
  const { step } = state;
  const index = getThumbnailIndex(state, targetTS);

  if (index == null) {
    return null;
  }
  const roundedTS = Math.floor(targetTS / step) * step;
  const targetMoment = dayjs.unix(roundedTS).utc();
  const pathParts = [
    targetMoment.format("YYYYMMDD"),
    targetMoment.hour(),
    `${index}.jpg`
  ];
  const link = `${state.base}/${state.path}/${pathParts.join("/")}`;
  return link;
}
/**
 * Get count of seconds passed from hour's begin
 * @param {Object} date Dayjs date
 */
function getSecondsOfHour(date) {
  return date.minute() * 60 + date.second();
}
/**
 * Return thumbnail index padded to 4 digits
 * @param {Object} state Store object
 * @param {Number} targetTS unix timestamp
 */
function getThumbnailIndex(state, targetTS) {
  const { step, first } = state;
  const roundedTS = Math.floor(targetTS / step) * step;
  const targetMoment = dayjs.unix(roundedTS).utc();

  const expectedIndex = getSecondsOfHour(targetMoment);
  const index =
    (first.index + Math.round((expectedIndex - first.index) / step) * step) %
    3600;
  if(!index){
    return null;
  }
  return pad(index, 4);
}

/**
 * Pad number by zeros from left to fix count of digits
 * @param {Number} n Number
 * @param {Number} width Digits count
 */
function pad(n, width) {
  // convert to string
  n = n + "";
  // return padded
  return n.length >= width ? n : new Array(width - n.length + 1).join("0") + n;
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
